import React, { useContext, useEffect, useState } from 'react'
import { Button, Card, Col, Row } from 'react-bootstrap'
import { FaChartLine, FaImages, FaPencilAlt, FaUsers, FaTrash, FaTicketAlt } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { UserContext } from '../../context/user-context'
import { FaPerson } from 'react-icons/fa6'
import EventDoormanModal from './doorman-modal'

export default function EventsContainerCard({ limit }) {
  const { userToken, user } = useContext(UserContext)
  const [events, setEvents] = useState([])
  const [loadingEvents, setLoadingEvents] = useState(true)
  const [showEventDoormanModal, setShowEventDoormanModal] = useState(false)
  const [selectedEventForDoorman, setSelectedEventForDoorMan] = useState(null)

  useEffect(() => {
    fetchEvents()
  }, [])

  useEffect(() => {
    setShowEventDoormanModal(selectedEventForDoorman != null)
  }, [selectedEventForDoorman])

  useEffect(() => {
    if (showEventDoormanModal === false) {
      setSelectedEventForDoorMan(null)
    }
  }, [showEventDoormanModal])

  const fetchEvents = async () => {
    try {
      const time = new Date().getTime()
      let url = process.env.REACT_APP_API_BASE_URL + `/wp-json/gnetwork/v1/brands/${user?.ID}/events?timestamp=${time}`
      if (limit) {
        url += '&limit=' + limit
      }
      const response = await axios.get(url, {
        headers: {
          'Authorization': 'Basic ' + btoa(user.user_login + ':' + userToken),
          'Content-Type': 'application/json',
        },
      })
      // console.log(response);
      if (response.data) {
        let temp_events = response.data.events
        setEvents(temp_events.reverse())
      }
      setLoadingEvents(false)
    } catch (error) {
      console.error('There was an error fetching orders:', error)
    }
  }

  const publishDraftEvent = async (event, key) => {
    try {
      let url = process.env.REACT_APP_API_BASE_URL + `/wp-json/gnetwork/v1/events/${event.ID}/publish`
      const response = await axios.post(
        url,
        {},
        {
          headers: {
            'Authorization': 'Basic ' + btoa(user.user_login + ':' + userToken),
            'Content-Type': 'application/json',
          },
        }
      )
      if (response.data) {
        fetchEvents()
      }
    } catch (error) {
      console.error('There was an error fetching orders:', error)
    }
  }

  const deleteEvent = async (event) => {
    try {
      let url = process.env.REACT_APP_API_BASE_URL + `/wp-json/gnetwork/v1/events/${event.ID}`
      const response = await axios.delete(url, {
        headers: {
          'Authorization': 'Basic ' + btoa(user.user_login + ':' + userToken),
          'Content-Type': 'application/json',
        },
      })
      if (response.data) {
        fetchEvents()
      }
    } catch (error) {
      console.error('There was an error deleting events:', error)
    }
  }
  {
    /* Disable Editing Past/Ended Events */
  }
  return (
    <Card className='w-100 mb-3'>
      <Card.Body>
        {/* <Card.Title>Events</Card.Title> */}
        {loadingEvents && <p>Loading...</p>}
        {!loadingEvents && events.length > 0 && (
          <div className='event-items'>
            {events.map((event, key) => {
              const eventButtons = []
              eventButtons.push(
                <Link
                  to={'/events/' + event.ID}
                  className='btn btn-primary'>
                  <FaPencilAlt />
                </Link>
              )
              if (event.post_status == 'draft') {
                eventButtons.push(
                  <Link
                    to={'/events/' + event.ID + '/tickets'}
                    className='btn btn-secondary'>
                    <FaTicketAlt />
                  </Link>
                )
              }
              if (event.post_status == 'draft') {
                eventButtons.push(
                  <Button variant='danger' onClick={() => {
                    deleteEvent(event)
                  }}>
                    <FaTrash />
                  </Button>
                )
              }
              if (event.post_status == 'publish') {
                eventButtons.push(
                  <Link
                    to={'/events/' + event.ID + '/stats'}
                    className='btn btn-success'>
                    <FaChartLine />
                  </Link>
                )
                eventButtons.push(
                  <Link
                    to={'/events/' + event.ID + '/team'}
                    className='btn btn-info'>
                    <FaUsers />
                  </Link>
                )
                eventButtons.push(
                  <Link
                    to={'/events/' + event.ID + '/gallery'}
                    className='btn btn-purple'>
                    <FaImages />
                  </Link>
                )
                eventButtons.push(
                  <Link
                    onClick={() => {
                      setSelectedEventForDoorMan(event.ID)
                    }}
                    className='btn btn-warning'
                  >
                    <FaPerson />
                  </Link>
                )
              }
              let status_text = event.post_status
              if (status_text == 'publish') {
                status_text = event.is_upcoming ? 'Live' : 'Ended'
              }
              return (
                <div
                  key={event.ID}
                  className={`event-item ${loadingEvents ? 'loading-skeleton' : ''}`}>
                  <Row>
                    {event.image_url && (
                      <Col
                        sm='auto'
                        className='event-item_img-wrap'>
                        <img
                          className='event-item_img'
                          src={event?.image_url}
                          alt={event.post_title}
                        />
                      </Col>
                    )}
                    <Col
                      sm
                      className='event-item_details py-3 d-flex align-items-center'>
                      <div>
                        <h4>
                          {event.post_status === 'publish' ? (
                            <Link
                              to={'/events/' + event.ID + '/stats'}
                              className='text-white'>
                              {event.post_title}
                            </Link>
                          ) : (
                            <>{event.post_title}</>
                          )}
                        </h4>
                        {/* <div>{event.formatted_date}</div> */}
                        <div>{event.shortened_formatted_date}</div>
                        <div className='event-status status-draft'>
                          <span className='status-circle status-draft'></span>
                          {status_text}
                        </div>
                      </div>
                    </Col>
                    <Col
                      sm
                      className='event-item_actions py-3'>
                        {eventButtons.map(eventButton => {
                          return eventButton
                        })}
                      </Col>
                  </Row>
                </div>
              )
            })}
            <EventDoormanModal
              selectedEventForDoorman={selectedEventForDoorman}
              showEventDoormanModal={showEventDoormanModal}
              setShowEventDoormanModal={setShowEventDoormanModal}
            />
          </div>
        )}
        {!loadingEvents && events.length == 0 && <p>You don't have any events in your</p>}
      </Card.Body>
    </Card>
  )
}
